/* Programme A/B (11/10/2026), test « tiroir », version D « remise » : −10 % contre l'e-mail, dans le panier latéral.
 * Bloc rendu par snippets/rs-panier-ab.liquid (zone 'pied'), visible avec html[data-v-tiroir="remise"].
 * Le tiroir est re-rendu en AJAX : tout passe par délégation d'événements sur document.
 *   1. « Obtenir 10 % de réduction » → le champ e-mail apparaît ;
 *   2. envoi → inscription à la liste Klaviyo (API client, comme sections/email-popup-klaviyo.liquid) si la clé publique
 *      est renseignée ci-dessous ; sans clé, l'inscription est sautée (le code est quand même donné) ;
 *   3. le code BIENVENUE10 est appliqué au panier (/cart/update.js { discount }), puis le tiroir est re-rendu :
 *      le bloc affiche alors « Code BIENVENUE10 appliqué » (lu par Liquid dans les remises du panier).
 * Entrée dans le champ : le bloc est dans le formulaire du panier, on empêche donc l'envoi vers le paiement.
 * Suivi CRO : tiroir_remise_email seulement quand l'inscription Klaviyo a réussi (bouton ou Entrée), jamais au simple
 * clic (adresse invalide, échec Klaviyo) : c'est le compteur « e-mails laissés » du tableau (programme.js).
 */
(function () {
  // Socle 1.1.0 (04/11/2026) : clé publique (Site ID) et liste « Bienvenue » du compte Klaviyo DE LA BOUTIQUE, posées par
  // snippets/boutique-specifique (partie « klaviyo », window.CRO_KLAVIYO). Sans clé : inscription sautée, code donné quand même.
  var KLAV = window.CRO_KLAVIYO || {};
  var KLAVIYO_CLE = KLAV.cle || '';
  var KLAVIYO_LISTE = KLAV.liste || '';
  var CODE = 'BIENVENUE10';

  function bloc(el) { return el && el.closest ? el.closest('[data-rsab-remise]') : null; }
  function rafraichir() {
    if (window.rsAB && rsAB.rafraichir) { rsAB.rafraichir(); return; }
    fetch('/?sections=side-cart', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      if (window.ajaxCart && ajaxCart.load) ajaxCart.load({ sections: s }, false);
    }).catch(function () {});
  }
  function inscrire(email) {
    if (!KLAVIYO_CLE) return Promise.resolve(true);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_CLE), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Tiroir −10 % (test tiroir-2)',
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LISTE } } } } })
    }).then(function (r) { if (r.status !== 202) throw new Error('klaviyo ' + r.status); return true; });
  }
  function appliquer() {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: CODE }) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .catch(function () { return fetch('/discount/' + CODE, { credentials: 'same-origin' }); });
  }
  function envoyer(b) {
    var champ = b.querySelector('[data-rsab-email]'), btn = b.querySelector('[data-rsab-envoyer]'), err = b.querySelector('[data-rsab-err]');
    var email = (champ && champ.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { if (err) err.hidden = false; if (champ) champ.focus(); return; }
    if (err) err.hidden = true;
    if (btn) btn.disabled = true;
    try { localStorage.setItem('rs_remise_email', '1'); } catch (e) {}
    inscrire(email).then(function (ok) {
      if (ok && KLAVIYO_CLE && window.croTrack) { try { croTrack('tiroir_remise_email', { label: 'remise' }); } catch (e) {} }
    }, function () { return false; }).then(appliquer).then(rafraichir, rafraichir);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-rsab-ouvrir]')) {
      var b = bloc(t), f = b && b.querySelector('[data-rsab-form]');
      if (f) { f.hidden = false; t.closest('[data-rsab-ouvrir]').hidden = true; var c = f.querySelector('[data-rsab-email]'); if (c) c.focus(); }
      return;
    }
    if (t.closest('[data-rsab-envoyer]')) { e.preventDefault(); envoyer(bloc(t)); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-rsab-email]')) return;
    e.preventDefault(); e.stopPropagation(); envoyer(bloc(e.target));
  }, true);
})();

/* ── Programme A/B (11/10/2026), test « upsell », version D « duo » : spray + huile en un geste ──
 * Bouton [data-rsup-duo="idSpray,idHuile"] rendu par snippets/rs-upsell-panier.liquid. Un seul /cart/add.js (les deux
 * articles ensemble : jamais deux écritures du panier en parallèle), puis re-rendu du tiroir. Les remises automatiques
 * « Upsell spray / huile » font passer le duo à 30,80 € quand le panier contient le shampoing.
 */
(function () {
  var enCours = false;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rsup-duo]');
    if (!b || enCours) return;
    e.preventDefault();
    var ids = String(b.getAttribute('data-rsup-duo')).split(',').map(function (x) { return +x; }).filter(Boolean);
    if (!ids.length) return;
    enCours = true; b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }) })
      .then(function () {
        if (window.rsAB && rsAB.rafraichir) return rsAB.rafraichir();
        return fetch('/?sections=side-cart', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
          if (window.ajaxCart && ajaxCart.load) ajaxCart.load({ sections: s }, false);
        });
      })
      .catch(function () {})
      .then(function () { enCours = false; b.disabled = false; });
  });
})();
